export const getSnapAlignStyle = (index: number, snapPointIndexes?: Set<number>) => ({
  scrollSnapAlign: snapPointIndexes?.has(index) ? ('start' as const) : ('none' as const),
});
